module.exports = __webpack_public_path__ + "img/banner.37cb77c9.svg";